import React from "react";
import Logo from "@/components/Logo";

export default function SiteDisabled() {
  const year = new Date().getFullYear();
  return (
    <div className="min-h-screen flex flex-col bg-white text-[#0A0A0A] font-body relative overflow-hidden">
      <div className="gold-orb a" style={{ width: 360, height: 360, top: "-10%", left: "-5%" }} />
      <div className="gold-orb b" style={{ width: 280, height: 280, bottom: "-10%", right: "-10%" }} />

      <main className="flex-1 flex items-center justify-center p-6">
        <div className="relative text-center max-w-md">
          <Logo size={88} />
          <h1 className="mt-8 font-display text-3xl sm:text-4xl font-bold leading-tight">
            Estamos <span className="text-gradient-gold">en mantenimiento</span>
          </h1>
          <p className="mt-4 text-gray-600 text-base leading-relaxed">
            El sitio web está temporalmente inactivo. Volveremos en breve.
            Para asistencia inmediata, contáctanos por teléfono o email.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <a href="tel:+19787174044" className="btn-gold" data-testid="maintenance-call-btn">(978) 717-4044</a>
            <a href="mailto:service@mccleanfresh.com" className="btn-outline-gold" data-testid="maintenance-email-btn">Email</a>
          </div>
        </div>
      </main>

      <footer className="relative w-full px-6 py-5 text-center" data-testid="maintenance-footer">
        <p className="text-xs text-gray-500 tracking-wide">
          © {year} M&amp;C Clean Fresh. All Rights Reserved.
        </p>
        <p className="mt-1 text-xs text-gray-400 tracking-wide">
          Powered by{" "}
          <a
            href="https://www.SallyBetter.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#B8941F] hover:text-[#D4AF37] underline-offset-2 hover:underline transition-colors"
            data-testid="maintenance-powered-by-link"
          >
            www.SallyBetter.com
          </a>
        </p>
      </footer>
    </div>
  );
}
